import React from 'react';
import { useAuth } from '../firebase/AuthContext';
import './UserHeader.css';

const UserHeader = () => {
  const { userProfile } = useAuth();

  if (!userProfile) return null;

  return (
    <div className="user-header">
      <img
        src={userProfile.photoURL || '/img/icon.png'}
        alt="ユーザーアイコン"
        className="user-header-icon"
      />
      <span className="user-header-nickname">
        {userProfile.displayName || userProfile.nickname || 'ユーザー'}
      </span>
    </div>
  );
};

export default UserHeader;
